import { computed } from '@vue/composition-api';
import User from '@/orm/models/User/User';
import Settings from '@/orm/models/User/Settings';

export default function useUser() {
  const currentUser = computed(() => User.getAuthUser());
  const users = computed(() => User.query().withAllRecursive().all());

  async function putSettings(prop, value) {
    const payload = { [prop]: value };
    await Settings.api().update(payload);
  }

  async function getUsers() {
    await User.api().getUsers();
  }

  async function deleteUser(id, payload) {
    await User.api().deleteUser(id, payload);
    await User.delete(id);
  }

  async function createUser(payload) {
    await User.api().createUser(payload);
  }

  async function updateUser(id, payload) {
    await User.api().updateUser(id, payload);
  }

  async function updateNewUser(uid, payload) {
    await User.api().updateNewUser(uid, payload);
  }

  async function updateAndChangePassword(payload) {
    await User.api().updateAndChangePassword(payload);
  }

  async function fetchUserByCreatedUid(createdUid) {
    await User.api().fetchUserByCreatedUid(createdUid);
  }

  return {
    currentUser,
    users,
    company: computed(() => currentUser.value?.company),
    companySettings: computed(() => currentUser.value?.company?.settings),
    userSettings: computed(() => currentUser.value?.settings),
    putSettings,
    getUsers,
    deleteUser,
    createUser,
    updateUser,
    updateAndChangePassword,
    fetchUserByCreatedUid,
    updateNewUser,
  };
}
